import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  StateStoreActions,
  StateStoreSelectors,
  StateStoreReducer,
} from './index';
import { StateDto } from '@cradua/data';

@Injectable()
export class StateFacade {
  constructor(private store: Store<StateStoreReducer.StatePartialState>) {}

  stateRecord$ = this.store.select(StateStoreSelectors.getSelected);
  stateRecordError$ = this.store.select(StateStoreSelectors.getStateError);

  getselected() {
    return this.store.select(StateStoreSelectors.getSelected);
  }

  get isLoadingState() {
    this.store.dispatch(StateStoreActions.loadState());
    return this.store.select(StateStoreSelectors.loadingState);
  }

  get loadState() {
    this.store.dispatch(StateStoreActions.loadState());
    return this.store.select(StateStoreSelectors.getAllState);
  }

  addState(newState: StateDto[]) {
    this.store.dispatch(StateStoreActions.addState({ newState }));
  }

  updateState(updateState: StateDto[]) {
    this.store.dispatch(StateStoreActions.updateState({ updateState }));
  }

  removeState(ids: string[]) {
    console.log('id ', ids);
    this.store.dispatch(StateStoreActions.removeState({ ids }));
  }
}
